/* global $ */
import classnames from 'classnames';
import React from 'react';
import { FilterHidingContextProvider } from '../controls/FilterBar';
import Scroll from '../other/Scroll';
import styles from './ContentBox.scss';
import Strike from './Strike';
export default class ContentBox extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            maxHeight: '100%',
        };
        this.element = null;
        this.fitHeight = () => {
            const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            const $panel = $(this.element);
            const $app = $('#scroll-layout');
            const minDesktopWidth = 1025;
            if (screenWidth < minDesktopWidth) {
                this.setState({ maxHeight: '100%' });
                $panel.css({ 'overflow-y': 'visible' });
                $panel.closest('.row').css('height', 'auto');
            }
            else {
                const offsetTop = 500;
                if ($app.scrollTop() > $panel.offset().top - offsetTop) {
                    const heightOffset = 70;
                    const maxHeight = $(window.top).height() - heightOffset;
                    $panel.css({ 'overflow-y': 'auto' });
                    this.setState({ maxHeight });
                }
                else {
                    this.setState({ maxHeight: '100%' });
                    $panel.css({ 'overflow-y': 'visible' });
                }
            }
        };
        this.onRef = el => (this.element = el);
    }
    componentDidMount() {
        const { isScrolled, hasLimitScrollableContentHeight } = this.props;
        if (!isScrolled && !hasLimitScrollableContentHeight) {
            return;
        }
        const $app = $('#scroll-layout');
        $app.on('scroll', () => this.fitHeight());
        this.fitHeight();
    }
    componentWillUnmount() {
        const { isScrolled, hasLimitScrollableContentHeight } = this.props;
        if (!isScrolled && !hasLimitScrollableContentHeight) {
            return;
        }
        $('#scroll-layout').off('scroll');
    }
    render() {
        const { title, paragraph, children, hasMinimalHeight, className, strikeClassName, isTitleSubsection, isTitlePageTitle, dataCy, } = this.props;
        const { maxHeight } = this.state;
        const classNames = classnames('border-box-padding', styles.contentBox, {
            [styles.withMinHeight]: hasMinimalHeight,
        }, className);
        return (<Scroll autoHeightMax={maxHeight} className={classnames('border-box', className)} classNameInner={classNames} getRef={this.onRef} passProps={dataCy ? { 'data-cy': dataCy } : undefined}>
        <FilterHidingContextProvider>
          {title && (<Strike className={strikeClassName} isPageTitle={isTitlePageTitle} isSubsection={isTitleSubsection} title={title}/>)}

          {paragraph && <p className="mt-10">{paragraph}</p>}

          {children}
        </FilterHidingContextProvider>
      </Scroll>);
    }
}
ContentBox.defaultProps = {
    title: '',
    paragraph: null,
    isScrolled: false,
    hasMinimalHeight: false,
    hasLimitScrollableContentHeight: false,
    className: undefined,
    strikeClassName: undefined,
    isTitleSubsection: true,
    isTitlePageTitle: false,
};
